const CLE = "bkprod_suivi_statuts";
export const EVT_SUIVI_VU = "bkprod:suivi-vu";

const lireSnapshot = () => {
  try {
    return JSON.parse(localStorage.getItem(CLE) || "{}");
  } catch {
    return {};
  }
};

/** Nombre de tickets dont le statut a changé (ou nouveaux) depuis la dernière visite du Suivi. */
export const compterChangements = (tickets) => {
  const vu = lireSnapshot();
  const dejaVu = Object.keys(vu).length > 0;
  return tickets.filter((t) => (dejaVu ? vu[t.id] !== t.statut : false)).length;
};

/** Marque tous les tickets comme vus (appelé à l'ouverture de la page Suivi). */
export const marquerSuiviVu = (tickets) => {
  const snap = {};
  tickets.forEach((t) => {
    snap[t.id] = t.statut;
  });
  localStorage.setItem(CLE, JSON.stringify(snap));
  window.dispatchEvent(new Event(EVT_SUIVI_VU));
};
